import { render, staticRenderFns } from "./modelBox.vue?vue&type=template&id=1a35c5dc&scoped=true&"
import script from "./modelBox.vue?vue&type=script&lang=js&"
export * from "./modelBox.vue?vue&type=script&lang=js&"
import style0 from "./modelBox.vue?vue&type=style&index=0&id=1a35c5dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35c5dc",
  null
  
)

export default component.exports